import {TFunction} from 'i18next';
import {
  SECTION_ID_DURATION,
  SECTION_ID_FLOORS,
  SECTION_ID_ROOM_ACTIVITY_TYPE,
  SECTION_ID_ROOM_EQUIPEMENT,
  SECTION_ID_SEATS,
  constructFloorFilter,
  constructHaNDurationFilter,
  constructRoomActivityTypeFilter,
  constructRoomEquipementFilter,
  constructSeatFilter,
} from '../filterConstructors';
import {RoomActivity, RoomEquipment} from '@lib/store';
import {AppLanguage} from '@lib/utils';

export const constructHereAndNowRoomsFilter = (
  floors: {id: string; name: string}[],
  withDuration: boolean,
  t: TFunction,
  appLanguage: AppLanguage,
  availableActivityTypes: RoomActivity[],
  availableEquipement: RoomEquipment[],
  getIconName: (id: RoomEquipment) => string,
) => {
  const duration = constructHaNDurationFilter(t, appLanguage);
  const seatFilters = constructSeatFilter(t);
  const floorFilters = constructFloorFilter(floors, t);

  const equipement = constructRoomEquipementFilter(availableEquipement, getIconName, t);
  const activities = constructRoomActivityTypeFilter(availableActivityTypes, t);

  return {
    [SECTION_ID_DURATION]: withDuration ? duration : undefined,
    [SECTION_ID_SEATS]: seatFilters,
    [SECTION_ID_FLOORS]: floorFilters,
    [SECTION_ID_ROOM_EQUIPEMENT]: equipement,
    [SECTION_ID_ROOM_ACTIVITY_TYPE]: activities,
  };
};
